import { disconnect } from 'common/sockets/zap';

export default () => disconnect();
